export interface routeType {
  path: string
  component?: any
  children?: Array<routeType>
  meta?: {
    title?: string
    needLogin?: boolean
  }
  redirect?: string
}

// 路由注册 
const routes: Array<routeType> = [
  {
    path: "/",
    redirect: "/index",
  },
  {
    path: "/index",
    component: () => import("@/pages/index"),
    meta: {
      title: "",
    }
  },
  {
    path: "/login",
    component: () => import("@/pages/login"),
    meta: {
      title: "",
    }
  },
  {
    path: "/search",
    component: () => import("@/pages/search"),
    meta: {
      title: "",
    }
  },
  {
    path: "/resume",
    component: () => import("@/pages/resume"),
    meta: {
      title: "",
    }
  },
  {
    path: "/loginListTab",
    component: () => import("@/pages/loginListTab"),
    meta: {
      title: "",
    }
  },
  {
    path: "/messagenotification",
    component: () => import("@/pages/messagenotification"),
    meta: {
      title: "",
    }
  },
  {
    path: "/moreCompany",
    component: () => import("@/pages/moreCompany"),
    meta: {
      title: "",
    }
  },
  {
    path: "/personalTab",
    component: () => import("@/pages/personalTab"),
    meta: {
      title: "",
    }
  },
  {
    path: "/personal",
    component: () => import("@/pages/personal"),
    meta: {
      title: "",
    }
  },
  {
    path: "/onlineResume",
    component: () => import("@/pages/onlineResume"),
    meta: {
      title: "",
    }
  },
  {
    path: "/viewEnterprise",
    component: () => import("@/pages/viewEnterprise"),
    meta: {
      title: "",
    }
  },
  {
    path: "/viewPosition",
    component: () => import("@/pages/viewPosition"),
    meta: {
      title: "",
    }
  },
  {
    path: "/agreement",
    component: () => import("@/pages/agreement"),
    meta: {
      title: "",
    }
  },
  {
    path: "/searchCourse",
    component: () => import("@/pages/course/searchCourse"),
    meta: {
      title: "",
    }
  },
  {
    path: "*",
    component: () => import("@/pages/search"),
    meta: {
      title: "404"
    }
  },
  {
    path: "searchHome",
    component: () => import("@/pages/course/courseHome"), 
    meta: {
      title: ""
    }
  },
  {
    path: "courseDetail",
    component: () => import("@/pages/course/courseDetail"), 
    meta: {
      title: ""
    }
  },
  
];

export default routes;